import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, tl } from "@/lib/api";
import { Building2, Users, Package, Hammer, MessageSquare, TrendingUp, ArrowUpRight } from "lucide-react";

const Stat = ({ icon: Ic, label, value, href, testId }) => (
  <Link
    to={href}
    data-testid={testId}
    className="group border border-white/8 bg-[#121212] p-6 hover:border-[#d4af37]/40 transition flex flex-col gap-4"
  >
    <div className="flex items-center justify-between">
      <Ic className="h-6 w-6 text-[#d4af37]" />
      <ArrowUpRight className="h-4 w-4 text-white/40 group-hover:text-[#d4af37] transition" />
    </div>
    <div>
      <div className="font-display text-4xl tracking-tight">{value}</div>
      <div className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-white/55">{label}</div>
    </div>
  </Link>
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);
  return (
    <div data-testid="dashboard-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">Yönetim Paneli</p>
          <h1 className="mt-2 font-display font-extrabold tracking-tighter text-4xl md:text-5xl">Genel Bakış</h1>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat icon={Building2} label="Bina / Proje" value={stats?.building_count ?? "—"} href="/admin/yalitim" testId="stat-buildings" />
        <Stat icon={Users} label="Personel" value={stats?.personnel_count ?? "—"} href="/admin/personel" testId="stat-personnel" />
        <Stat icon={Package} label="Malzeme" value={stats?.material_count ?? "—"} href="/admin/malzeme" testId="stat-materials" />
        <Stat icon={Hammer} label="Yap-Sat Proje" value={stats?.yapsat_count ?? "—"} href="/admin/yapsat" testId="stat-yapsat" />
        <Stat icon={MessageSquare} label="Yeni Mesaj" value={stats?.unread_messages ?? "—"} href="/admin/mesajlar" testId="stat-messages" />
        <Stat icon={TrendingUp} label="Daire Sayısı" value={stats?.apartment_count ?? "—"} href="/admin/yalitim" testId="stat-apartments" />
      </div>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="border border-white/8 bg-[#121212] p-6">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/45">Toplam Sözleşme</p>
          <div className="mt-3 font-display text-4xl text-[#d4af37]">{tl(stats?.total_contract || 0)}</div>
        </div>
        <div className="border border-white/8 bg-[#121212] p-6">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/45">Tahsil Edilen</p>
          <div className="mt-3 font-display text-4xl">{tl(stats?.total_paid || 0)}</div>
        </div>
        <div className="border border-white/8 bg-[#121212] p-6">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/45">Kalan Alacak</p>
          <div className="mt-3 font-display text-4xl text-white/80">{tl(stats?.total_remaining || 0)}</div>
        </div>
      </div>
    </div>
  );
}
